import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export var AnnualDiscountKind;
(function (AnnualDiscountKind) {
    AnnualDiscountKind["Percent"] = "PERCENT";
    AnnualDiscountKind["Period"] = "PERIOD";
})(AnnualDiscountKind || (AnnualDiscountKind = {}));
export var BusinessSegment;
(function (BusinessSegment) {
    BusinessSegment["Events"] = "EVENTS";
    BusinessSegment["Retail"] = "RETAIL";
})(BusinessSegment || (BusinessSegment = {}));
export var CampaignGoalKind;
(function (CampaignGoalKind) {
    CampaignGoalKind["AnnualRevenue"] = "ANNUAL_REVENUE";
    CampaignGoalKind["Members"] = "MEMBERS";
    CampaignGoalKind["MonthlyRevenue"] = "MONTHLY_REVENUE";
})(CampaignGoalKind || (CampaignGoalKind = {}));
export var CurationMatchMode;
(function (CurationMatchMode) {
    CurationMatchMode["Product"] = "PRODUCT";
    CurationMatchMode["Variant"] = "VARIANT";
})(CurationMatchMode || (CurationMatchMode = {}));
export var CurationStatus;
(function (CurationStatus) {
    CurationStatus["Approved"] = "APPROVED";
    CurationStatus["Flagged"] = "FLAGGED";
    CurationStatus["Proposed"] = "PROPOSED";
})(CurationStatus || (CurationStatus = {}));
export var DeliveryMethod;
(function (DeliveryMethod) {
    DeliveryMethod["Pickup"] = "PICKUP";
    DeliveryMethod["Shipping"] = "SHIPPING";
})(DeliveryMethod || (DeliveryMethod = {}));
export var DeliveryStrategy;
(function (DeliveryStrategy) {
    DeliveryStrategy["Annual"] = "ANNUAL";
    DeliveryStrategy["Biweekly"] = "BIWEEKLY";
    DeliveryStrategy["Custom"] = "CUSTOM";
    DeliveryStrategy["Immediately"] = "IMMEDIATELY";
    DeliveryStrategy["Monthly"] = "MONTHLY";
    DeliveryStrategy["Once"] = "ONCE";
    DeliveryStrategy["Quarterly"] = "QUARTERLY";
    DeliveryStrategy["Weekly"] = "WEEKLY";
})(DeliveryStrategy || (DeliveryStrategy = {}));
export var DiscountPlatform;
(function (DiscountPlatform) {
    DiscountPlatform["Eventbrite"] = "EVENTBRITE";
    DiscountPlatform["Shopify"] = "SHOPIFY";
    DiscountPlatform["Square"] = "SQUARE";
})(DiscountPlatform || (DiscountPlatform = {}));
export var DiscountScope;
(function (DiscountScope) {
    DiscountScope["Event"] = "EVENT";
    DiscountScope["Retail"] = "RETAIL";
})(DiscountScope || (DiscountScope = {}));
export var FulfillmentInvoiceStatus;
(function (FulfillmentInvoiceStatus) {
    FulfillmentInvoiceStatus["Draft"] = "DRAFT";
    FulfillmentInvoiceStatus["Finalized"] = "FINALIZED";
    FulfillmentInvoiceStatus["Paid"] = "PAID";
})(FulfillmentInvoiceStatus || (FulfillmentInvoiceStatus = {}));
export var MembershipCancellationReason;
(function (MembershipCancellationReason) {
    MembershipCancellationReason["ByOrganizer"] = "By_Organizer";
    MembershipCancellationReason["DidNotUse"] = "Did_Not_Use";
    MembershipCancellationReason["HardToUse"] = "Hard_To_Use";
    MembershipCancellationReason["LifeIsHard"] = "Life_Is_Hard";
    MembershipCancellationReason["Other"] = "Other";
    MembershipCancellationReason["PrePurchase"] = "Pre_Purchase";
})(MembershipCancellationReason || (MembershipCancellationReason = {}));
export var MembershipKind;
(function (MembershipKind) {
    MembershipKind["Friend"] = "Friend";
    MembershipKind["Honorary"] = "Honorary";
    MembershipKind["Legacy"] = "Legacy";
    MembershipKind["Live"] = "Live";
    MembershipKind["Retired"] = "Retired";
})(MembershipKind || (MembershipKind = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["Active"] = "Active";
    MembershipStatus["Cancelled"] = "Cancelled";
    MembershipStatus["Ended"] = "Ended";
    MembershipStatus["New"] = "New";
})(MembershipStatus || (MembershipStatus = {}));
export var MoneyFormat;
(function (MoneyFormat) {
    MoneyFormat["Presentment"] = "Presentment";
    MoneyFormat["Shop"] = "Shop";
})(MoneyFormat || (MoneyFormat = {}));
export var Ordering;
(function (Ordering) {
    Ordering["Asc"] = "ASC";
    Ordering["Desc"] = "DESC";
})(Ordering || (Ordering = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Charged"] = "CHARGED";
    PaymentStatus["Completed"] = "COMPLETED";
    PaymentStatus["Failed"] = "FAILED";
    PaymentStatus["Finalized"] = "FINALIZED";
    PaymentStatus["Ignore"] = "IGNORE";
    PaymentStatus["ItemCharged"] = "ITEM_CHARGED";
    PaymentStatus["MembershipCharged"] = "MEMBERSHIP_CHARGED";
    PaymentStatus["New"] = "NEW";
    PaymentStatus["OffPlatform"] = "OFF_PLATFORM";
    PaymentStatus["Refunded"] = "REFUNDED";
})(PaymentStatus || (PaymentStatus = {}));
export var Period;
(function (Period) {
    Period["Day"] = "DAY";
    Period["Month"] = "MONTH";
    Period["Week"] = "WEEK";
    Period["Year"] = "YEAR";
})(Period || (Period = {}));
export var PlanKind;
(function (PlanKind) {
    PlanKind["Annual"] = "ANNUAL";
    PlanKind["Monthly"] = "MONTHLY";
    PlanKind["Weekly"] = "WEEKLY";
})(PlanKind || (PlanKind = {}));
export var PlatformIdKind;
(function (PlatformIdKind) {
    PlatformIdKind["DraftOrder"] = "DraftOrder";
    PlatformIdKind["Order"] = "Order";
})(PlatformIdKind || (PlatformIdKind = {}));
export var PlatformMode;
(function (PlatformMode) {
    PlatformMode["InStore"] = "IN_STORE";
    PlatformMode["Online"] = "ONLINE";
})(PlatformMode || (PlatformMode = {}));
export var PlatformName;
(function (PlatformName) {
    PlatformName["Basil"] = "BASIL";
    PlatformName["Bookmanager"] = "BOOKMANAGER";
    PlatformName["Clover"] = "CLOVER";
    PlatformName["Direct"] = "DIRECT";
    PlatformName["Eventbrite"] = "EVENTBRITE";
    PlatformName["Indiecommerce"] = "INDIECOMMERCE";
    PlatformName["Indiecommerce2"] = "INDIECOMMERCE2";
    PlatformName["Lightspeed"] = "LIGHTSPEED";
    PlatformName["Other"] = "OTHER";
    PlatformName["Shopify"] = "SHOPIFY";
    PlatformName["Square"] = "SQUARE";
    PlatformName["Squarespace"] = "SQUARESPACE";
    PlatformName["Toast"] = "TOAST";
})(PlatformName || (PlatformName = {}));
export var ThemeBadgeAlignment;
(function (ThemeBadgeAlignment) {
    ThemeBadgeAlignment["Left"] = "LEFT";
    ThemeBadgeAlignment["Right"] = "RIGHT";
})(ThemeBadgeAlignment || (ThemeBadgeAlignment = {}));
export var TransactionKind;
(function (TransactionKind) {
    TransactionKind["Addon"] = "Addon";
    TransactionKind["Base"] = "Base";
})(TransactionKind || (TransactionKind = {}));
export var VideoPlatform;
(function (VideoPlatform) {
    VideoPlatform["Vimeo"] = "VIMEO";
    VideoPlatform["Youtube"] = "YOUTUBE";
})(VideoPlatform || (VideoPlatform = {}));
export const CreateMembershipTierInputFragmentDoc = gql `
    fragment CreateMembershipTierInput on MembershipTier {
  name
  defaultMode
  plans {
    kind
    price {
      amount
    }
  }
  discounts {
    scope
    percentage
  }
}
    `;
export const SaveSubscriptionBenefitFragmentDoc = gql `
    fragment SaveSubscriptionBenefit on SubscriptionBenefit {
  business {
    id
    enableAutomatedCuration
    enableProductSwapping
    includeWelcomeGiftInFirstShipment
  }
  name
  shippingNotesInstructions
  nextShipmentDate
  delivery
  deliveryFrequency
  shippingEnabled
  pickupEnabled
  claimable
  shippingCost {
    amount
  }
  shippingFrequency {
    period
    number
  }
  firstShipmentDelay
  isAddonOnly
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    curationValue
    curationCollections
    curationExcludeProducts
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
      curationExcludeProducts
      curationIncludeVariants
      curationSearchTerms
      curationStatus
      curationError
      flagReason
    }
  }
  variants {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
  addons {
    id
    description
    applyDiscount
    dontRollOver
    platformId
    platformName
    additionalCost {
      amount
    }
  }
  curationMatchMode
  curationPreferOverstock
  membershipTiers {
    plans {
      kind
      price {
        amount
      }
    }
  }
}
    `;
export const SaveWelcomeGiftBenefitFragmentDoc = gql `
    fragment SaveWelcomeGiftBenefit on WelcomeGiftBenefit {
  business {
    id
    includeWelcomeGiftInFirstShipment
    enableAutomatedCuration
    enableProductSwapping
  }
  shippingEnabled
  pickupEnabled
  claimable
  shippingCost {
    amount
  }
  name
  shippingNotesInstructions
  delivery
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
    }
  }
  variants {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
}
    `;
export const SaveDriveBenefitFragmentDoc = gql `
    fragment SaveDriveBenefit on DriveBenefit {
  business {
    id
    includeWelcomeGiftInFirstShipment
    enableAutomatedCuration
    enableProductSwapping
  }
  shippingEnabled
  pickupEnabled
  claimable
  shippingCost {
    amount
  }
  name
  shippingNotesInstructions
  products {
    id
    name
    platformId
    platformName
    platformVariantsOnlyMode
    variants {
      id
      description
      additionalCost {
        amount
      }
      platformName
      platformId
    }
  }
}
    `;
export const ChooseSubscriptionScreenAddonFragmentDoc = gql `
    fragment ChooseSubscriptionScreenAddon on Addon {
  id
  description
  additionalCost {
    amount
  }
  applyDiscount
}
    `;
export const ChooseSubscriptionScreenAddressFragmentDoc = gql `
    fragment ChooseSubscriptionScreenAddress on Address {
  shippingName
  line1
  line2
  city
  state
  zip
  country
}
    `;
export const ChooseSubscriptionScreenVariantFragmentDoc = gql `
    fragment ChooseSubscriptionScreenVariant on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
}
    `;
export const ChooseSubscriptionScreenProductFragmentDoc = gql `
    fragment ChooseSubscriptionScreenProduct on Product {
  id
  name
  platformId
  platformName
  platformVariantsOnlyMode
  variants {
    ...ChooseSubscriptionScreenVariant
  }
}
    ${ChooseSubscriptionScreenVariantFragmentDoc}`;
export const ChooseProductSelectionFragmentDoc = gql `
    fragment ChooseProductSelection on ProductSelection {
  product {
    ...ChooseSubscriptionScreenProduct
  }
  variant {
    ...ChooseSubscriptionScreenVariant
  }
}
    ${ChooseSubscriptionScreenProductFragmentDoc}
${ChooseSubscriptionScreenVariantFragmentDoc}`;
export const SaveFulfillmentSettingsFragmentDoc = gql `
    fragment SaveFulfillmentSettings on Fulfillment {
  id
  fulfillmentDate
  benefit {
    id
  }
  variant {
    id
  }
  addons {
    ...ChooseSubscriptionScreenAddon
  }
  address {
    ...ChooseSubscriptionScreenAddress
  }
  productSelections {
    ...ChooseProductSelection
  }
  shippingNotes
}
    ${ChooseSubscriptionScreenAddonFragmentDoc}
${ChooseSubscriptionScreenAddressFragmentDoc}
${ChooseProductSelectionFragmentDoc}`;
export const CopyAddressFragmentDoc = gql `
    fragment CopyAddress on Fulfillment {
  address {
    ...ChooseSubscriptionScreenAddress
  }
  shippingNotes
}
    ${ChooseSubscriptionScreenAddressFragmentDoc}`;
export const UpdateSquarespaceShopFragmentDoc = gql `
    fragment UpdateSquarespaceShop on Business {
  squarespaceShop
}
    `;
export const MembershipWithfriendsTransactionFragmentDoc = gql `
    fragment MembershipWithfriendsTransaction on Transaction {
  id
  time
  amount {
    amount
  }
  currencyCode
  paymentStatus
  kind
}
    `;
export const MembershipShopifyOrderFragmentDoc = gql `
    fragment MembershipShopifyOrder on ShopifyOrder {
  id
  createdAt
  customerMembershipTotal
  customerCurrencyCode
  status
}
    `;
export const MembershipFulfillmentAddonFragmentDoc = gql `
    fragment MembershipFulfillmentAddon on Addon {
  id
  description
  additionalCost {
    amount
  }
}
    `;
export const MembershipFulfillmentFragmentDoc = gql `
    fragment MembershipFulfillment on Fulfillment {
  curated
  id
  fulfillmentDate
  isFulfilled
  productSelections {
    ...ChooseProductSelection
  }
  variant {
    id
    description
    additionalCost {
      amount
    }
    platformName
    platformId
  }
  addons {
    ...MembershipFulfillmentAddon
  }
  benefit {
    id
    name
    ... on SubscriptionBenefit {
      shippingIncluded
      deliveredToYour
    }
    variants {
      id
    }
    products {
      id
      variants {
        id
      }
    }
    ... on SubscriptionBenefit {
      claimable
    }
    ... on WelcomeGiftBenefit {
      claimable
    }
    ... on DriveBenefit {
      claimable
    }
  }
  address {
    shippingName
    line1
    line2
    city
    state
    zip
    country
  }
  trackingUrl
  shippingNotes
  deliveryMethod
  claimedAt
  membership {
    user {
      id
      emailAddress
    }
  }
}
    ${ChooseProductSelectionFragmentDoc}
${MembershipFulfillmentAddonFragmentDoc}`;
export const UserMembershipsFragmentDoc = gql `
    fragment UserMemberships on Membership {
  id
  activated
  ended
  statusDescription(asUserId: $id)
  pauseStartDate
  pauseEndDate
  user {
    id
    firstName
    lastName
    emailAddress
  }
  purchaser {
    id
    firstName
    lastName
  }
  plan {
    kind
  }
  tier {
    id
    name
    kind
    business {
      id
      alias
      name
      shopifyVersion
      shopifyShop
      segment
      website
      inAnotherCastle
    }
    discounts {
      scope
      percentage
      code {
        text
      }
    }
    commitment
  }
  withfriendsTransactions {
    ...MembershipWithfriendsTransaction
  }
  shopifyOrders {
    ...MembershipShopifyOrder
  }
  fulfilledFulfillments: fulfillments(query: {isFulfilled: true}) {
    ...MembershipFulfillment
  }
  unfulfilledFulfillments: fulfillments(query: {isFulfilled: false}) {
    ...MembershipFulfillment
  }
}
    ${MembershipWithfriendsTransactionFragmentDoc}
${MembershipShopifyOrderFragmentDoc}
${MembershipFulfillmentFragmentDoc}`;
export const VariantFragmentFragmentDoc = gql `
    fragment VariantFragment on Variant {
  id
  description
  additionalCost {
    amount
  }
  platformName
  platformId
  curationExcludeProducts
  curationIncludeVariants
  curationSearchTerms
  curationStatus
}
    `;
export const AddonFragmentFragmentDoc = gql `
    fragment AddonFragment on Addon {
  id
  description
  applyDiscount
  dontRollOver
  platformId
  platformName
  additionalCost {
    amount
  }
}
    `;
export const BenefitFragmentFragmentDoc = gql `
    fragment BenefitFragment on Benefit {
  __typename
  id
  name
  ... on SubscriptionBenefit {
    delivery
    isAddonOnly
    nextShipmentDate
    shippingFrequency {
      number
      period
    }
    deliveryFrequency
    firstShipmentDelay
    curationPreferOverstock
    curationMatchMode
    products {
      id
      name
      platformId
      platformName
      platformVariantsOnlyMode
      variants {
        ...VariantFragment
      }
      curationValue
      curationCollections
      curationExcludeProducts
    }
    variants {
      ...VariantFragment
    }
    addons {
      ...AddonFragment
    }
    membershipTiers {
      id
      name
    }
  }
}
    ${VariantFragmentFragmentDoc}
${AddonFragmentFragmentDoc}`;
export const MembershipTierFragmentFragmentDoc = gql `
    fragment MembershipTierFragment on MembershipTier {
  id
  name
  manualDiscountCode
  defaultMode
  plans {
    kind
    price {
      amount
    }
  }
  discounts {
    scope
    percentage
    guests
  }
  image {
    id
    url
    cdnPath
  }
  benefits {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
export const BusinessFragmentFragmentDoc = gql `
    fragment BusinessFragment on Business {
  id
  name
  alias
  status
  oneLiner
  mission
  currencySymbol
  currencyCode
  qualifierOrderValue
  qualifierCustomers
  stripeId
  enableEmailUpsell
  enableSmsUpsell
  enablePastCustomerUpsell
  enableRedirectUpsell
  enableTips
  address {
    neighborhood
    city
    stateAbbreviated
  }
  coverPhoto {
    id
    url
    cdnPath
  }
  logo {
    id
    url
    cdnPath
  }
  platforms {
    name
    mode
    connected
  }
  features {
    name
    completed
  }
  membershipTiers(kind: Live) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
export const UpdateBusinessFragmentFragmentDoc = gql `
    fragment UpdateBusinessFragment on Business {
  id
  oneLiner
  mission
  enableEmailUpsell
  enableSmsUpsell
  enablePastCustomerUpsell
  enableRedirectUpsell
  enableTips
  shopifyShop
  shopifyVersion
}
    `;
export const UpdateBusinessFragmentDoc = gql `
    fragment UpdateBusiness on Business {
  ...UpdateBusinessFragment
}
    ${UpdateBusinessFragmentFragmentDoc}`;
export const CreateMembershipTierDocument = gql `
    mutation CreateMembershipTier($businessId: ID!, $membershipInput: MembershipTierInput!) {
  updateOrCreateMembership(
    businessId: $businessId
    membershipInput: $membershipInput
  ) {
    id
    name
    manualDiscountCode
    defaultMode
    overridePlatformProductSync
    plans {
      kind
      price {
        amount
      }
    }
    discounts {
      scope
      percentage
    }
    image {
      id
      url
      cdnPath
    }
    subscriptionBenefit {
      id
      name
      membershipTiers {
        id
        name
      }
      delivery
      nextShipmentDate
      isAddonOnly
    }
    benefits {
      __typename
      id
      name
      membershipTiers {
        id
        name
      }
      ... on SubscriptionBenefit {
        delivery
      }
    }
  }
}
    `;
/**
 * __useCreateMembershipTierMutation__
 *
 * To run a mutation, you first call `useCreateMembershipTierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMembershipTierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMembershipTierMutation, { data, loading, error }] = useCreateMembershipTierMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      membershipInput: // value for 'membershipInput'
 *   },
 * });
 */
export function useCreateMembershipTierMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateMembershipTierDocument, options);
}
export const SaveSubscriptionOrWelcomeGiftOrDriveBenefitDocument = gql `
    mutation SaveSubscriptionOrWelcomeGiftOrDriveBenefit($id: ID!, $benefit: BenefitInput!) {
  updateBenefit(id: $id, benefit: $benefit) {
    id
    name
    ... on SubscriptionBenefit {
      ...SaveSubscriptionBenefit
    }
    ... on WelcomeGiftBenefit {
      ...SaveWelcomeGiftBenefit
    }
    ... on DriveBenefit {
      ...SaveDriveBenefit
    }
  }
}
    ${SaveSubscriptionBenefitFragmentDoc}
${SaveWelcomeGiftBenefitFragmentDoc}
${SaveDriveBenefitFragmentDoc}`;
/**
 * __useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation__
 *
 * To run a mutation, you first call `useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSubscriptionOrWelcomeGiftOrDriveBenefitMutation, { data, loading, error }] = useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      benefit: // value for 'benefit'
 *   },
 * });
 */
export function useSaveSubscriptionOrWelcomeGiftOrDriveBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(SaveSubscriptionOrWelcomeGiftOrDriveBenefitDocument, options);
}
export const ClientInfoDocument = gql `
    query ClientInfo($id: ID!) {
  business(id: $id) {
    id
    status
    platforms {
      name
      mode
      connected
    }
    stripeId
    shopifyVersion
    membershipTiers(kind: Live) {
      defaultMode
    }
    currencySymbol
    currencyCode
  }
}
    `;
/**
 * __useClientInfoQuery__
 *
 * To run a query within a React component, call `useClientInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientInfoQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ClientInfoDocument, options);
}
export function useClientInfoLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ClientInfoDocument, options);
}
export function useClientInfoSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ClientInfoDocument, options);
}
export const EditSubscriptionBenefitButtonDocument = gql `
    query EditSubscriptionBenefitButton($id: ID!) {
  membershipTier(id: $id) {
    id
    subscriptionBenefit {
      id
    }
  }
}
    `;
/**
 * __useEditSubscriptionBenefitButtonQuery__
 *
 * To run a query within a React component, call `useEditSubscriptionBenefitButtonQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditSubscriptionBenefitButtonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditSubscriptionBenefitButtonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditSubscriptionBenefitButtonQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(EditSubscriptionBenefitButtonDocument, options);
}
export function useEditSubscriptionBenefitButtonLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(EditSubscriptionBenefitButtonDocument, options);
}
export function useEditSubscriptionBenefitButtonSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(EditSubscriptionBenefitButtonDocument, options);
}
export const Instore_QueryDocument = gql `
    query INSTORE_QUERY($id: ID!) {
  business(id: $id) {
    id
    alias
    name
    oneLiner
    status
    defaultRebate
    currencyCode
    shopifyVersion
    reports(reports: ["CustomerAnalyticsReport"]) {
      ... on CustomerAnalyticsReport {
        averageOrderValue {
          amount
        }
      }
    }
    logo {
      url
      cdnPath
    }
    theme {
      highlightColor
      darkColor
      defaultColor
      font
    }
    membershipTiers(kind: Live) {
      name
      plans {
        price {
          amount
        }
      }
      manualDiscountCode
      discounts {
        scope
        percentage
      }
      welcomeGift {
        name
      }
      subscriptionBenefit {
        name
      }
    }
  }
}
    `;
/**
 * __useInstore_QueryQuery__
 *
 * To run a query within a React component, call `useInstore_QueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstore_QueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstore_QueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstore_QueryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(Instore_QueryDocument, options);
}
export function useInstore_QueryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(Instore_QueryDocument, options);
}
export function useInstore_QuerySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(Instore_QueryDocument, options);
}
export const IntegrateQueryDocument = gql `
    query IntegrateQuery($id: ID!) {
  business(id: $id) {
    id
    alias
    name
    oneLiner
    status
    defaultRebate
    website
    logo {
      url
      cdnPath
    }
    theme {
      highlightColor
      darkColor
      defaultColor
      font
    }
    abbreviatedBenefits(isSuper: true)
    currencyCode
    membershipTiers {
      name
      manualDiscountCode
      discounts {
        scope
        percentage
        disclaimer
      }
      welcomeGift {
        name
      }
      subscriptionBenefit {
        name
        delivery
        deliveryFrequency
        shippingFrequency {
          number
          period
        }
      }
      plans {
        kind
        price {
          amount
        }
      }
    }
    platforms {
      name
      mode
      connected
    }
    features {
      name
      completed
    }
  }
}
    `;
/**
 * __useIntegrateQueryQuery__
 *
 * To run a query within a React component, call `useIntegrateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrateQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIntegrateQueryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(IntegrateQueryDocument, options);
}
export function useIntegrateQueryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(IntegrateQueryDocument, options);
}
export function useIntegrateQuerySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(IntegrateQueryDocument, options);
}
export const ManageFulfillmentsDocument = gql `
    query ManageFulfillments($id: ID!, $businessId: ID) {
  user(id: $id) {
    id
    emailAddress
    activeMemberships: memberships(
      businessId: $businessId
      status: Active
      includeGifted: true
    ) {
      ...UserMemberships
    }
    expiredMemberships: memberships(
      businessId: $businessId
      status: Ended
      includeGifted: true
    ) {
      ...UserMemberships
    }
  }
}
    ${UserMembershipsFragmentDoc}`;
/**
 * __useManageFulfillmentsQuery__
 *
 * To run a query within a React component, call `useManageFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManageFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManageFulfillmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      businessId: // value for 'businessId'
 *   },
 * });
 */
export function useManageFulfillmentsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(ManageFulfillmentsDocument, options);
}
export function useManageFulfillmentsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(ManageFulfillmentsDocument, options);
}
export function useManageFulfillmentsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(ManageFulfillmentsDocument, options);
}
export const GetProductVariantsDocument = gql `
    query GetProductVariants($id: ID!) {
  business(id: $id) {
    id
    shopifyProductsCount
    shopifyProductVariants {
      id
      displayName
      price
      inventory
      inventoryTracked
      productId
      productType
      vendor
      tags
      createdAt
      collections
      productTitle
      variantTitle
      description
      imageUrl
      onlineStoreUrl
      sku
    }
  }
}
    `;
/**
 * __useGetProductVariantsQuery__
 *
 * To run a query within a React component, call `useGetProductVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductVariantsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetProductVariantsDocument, options);
}
export function useGetProductVariantsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetProductVariantsDocument, options);
}
export function useGetProductVariantsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetProductVariantsDocument, options);
}
export const VerifyStripeAccountDocument = gql `
    mutation VerifyStripeAccount($id: ID!, $country: String) {
  verifyStripeAccount(id: $id, country: $country)
}
    `;
/**
 * __useVerifyStripeAccountMutation__
 *
 * To run a mutation, you first call `useVerifyStripeAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyStripeAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyStripeAccountMutation, { data, loading, error }] = useVerifyStripeAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *   },
 * });
 */
export function useVerifyStripeAccountMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(VerifyStripeAccountDocument, options);
}
export const WelcomeGiftVariantDocument = gql `
    query WelcomeGiftVariant($id: ID!) {
  fulfillment(id: $id) {
    id
    isGift
    fulfillmentDate
    fulfillmentDateAdjustmentReason
    ...SaveFulfillmentSettings
    benefit {
      id
      ... on SubscriptionBenefit {
        shippingIncluded
        deliveredToYour
      }
      name
      products {
        ...ChooseSubscriptionScreenProduct
      }
      variants {
        ...ChooseSubscriptionScreenVariant
      }
    }
    membership {
      purchaser {
        id
        firstName
        lastName
      }
      user {
        id
        firstName
        lastName
      }
    }
    platformLineItems {
      quantity
      platformProductVariantId
      swapped
    }
  }
}
    ${SaveFulfillmentSettingsFragmentDoc}
${ChooseSubscriptionScreenProductFragmentDoc}
${ChooseSubscriptionScreenVariantFragmentDoc}`;
/**
 * __useWelcomeGiftVariantQuery__
 *
 * To run a query within a React component, call `useWelcomeGiftVariantQuery` and pass it any options that fit your needs.
 * When your component renders, `useWelcomeGiftVariantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWelcomeGiftVariantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWelcomeGiftVariantQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(WelcomeGiftVariantDocument, options);
}
export function useWelcomeGiftVariantLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(WelcomeGiftVariantDocument, options);
}
export function useWelcomeGiftVariantSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(WelcomeGiftVariantDocument, options);
}
export const UserMembershipFulfillmentsDocument = gql `
    query UserMembershipFulfillments($id: ID!) {
  user(id: $id) {
    id
    memberships {
      id
      tier {
        id
        name
        business {
          alias
          name
        }
        discounts {
          scope
          percentage
        }
      }
      fulfillments(query: {isFulfilled: false}) {
        id
        fulfillmentDate
        variant {
          description
        }
        addons {
          description
          additionalCost {
            amount
          }
        }
        benefit {
          id
          name
        }
        address {
          line1
          line2
          city
          state
          zip
          country
        }
      }
    }
  }
}
    `;
/**
 * __useUserMembershipFulfillmentsQuery__
 *
 * To run a query within a React component, call `useUserMembershipFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMembershipFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMembershipFulfillmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserMembershipFulfillmentsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(UserMembershipFulfillmentsDocument, options);
}
export function useUserMembershipFulfillmentsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(UserMembershipFulfillmentsDocument, options);
}
export function useUserMembershipFulfillmentsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(UserMembershipFulfillmentsDocument, options);
}
export const FulfillmentMarkFulfilledDocument = gql `
    mutation FulfillmentMarkFulfilled($id: ID!) {
  fulfillmentMarkFulfilled(id: $id) {
    id
    isFulfilled
  }
}
    `;
/**
 * __useFulfillmentMarkFulfilledMutation__
 *
 * To run a mutation, you first call `useFulfillmentMarkFulfilledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentMarkFulfilledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillmentMarkFulfilledMutation, { data, loading, error }] = useFulfillmentMarkFulfilledMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFulfillmentMarkFulfilledMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(FulfillmentMarkFulfilledDocument, options);
}
export const FulfillmentBatchMarkFulfilledDocument = gql `
    mutation FulfillmentBatchMarkFulfilled($query: FulfillmentQuery!) {
  fulfillmentBatchMarkFulfilled(query: $query) {
    id
    isFulfilled
  }
}
    `;
/**
 * __useFulfillmentBatchMarkFulfilledMutation__
 *
 * To run a mutation, you first call `useFulfillmentBatchMarkFulfilledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFulfillmentBatchMarkFulfilledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fulfillmentBatchMarkFulfilledMutation, { data, loading, error }] = useFulfillmentBatchMarkFulfilledMutation({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFulfillmentBatchMarkFulfilledMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(FulfillmentBatchMarkFulfilledDocument, options);
}
export const GetMembershipDocument = gql `
    query GetMembership($membershipId: ID!, $fulfillmentQuery: FulfillmentQuery) {
  membership(id: $membershipId) {
    id
    user {
      id
      firstName
      lastName
      emailAddress
      phoneNumber
    }
    tier {
      id
      name
      benefits {
        ... on SubscriptionBenefit {
          id
          name
          delivery
        }
      }
    }
    fulfillments(query: $fulfillmentQuery) {
      id
      isFulfilled
      fulfillmentDate
      benefit {
        name
      }
      address {
        line1
        line2
        city
        state
        zip
        country
      }
      shippingNotes
      addons {
        id
        description
      }
      variant {
        id
        description
      }
    }
  }
}
    `;
/**
 * __useGetMembershipQuery__
 *
 * To run a query within a React component, call `useGetMembershipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipQuery({
 *   variables: {
 *      membershipId: // value for 'membershipId'
 *      fulfillmentQuery: // value for 'fulfillmentQuery'
 *   },
 * });
 */
export function useGetMembershipQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetMembershipDocument, options);
}
export function useGetMembershipLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetMembershipDocument, options);
}
export function useGetMembershipSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetMembershipDocument, options);
}
export const BusinessFulfillmentsDocument = gql `
    query BusinessFulfillments($id: ID!, $query: FulfillmentQuery) {
  business(id: $id) {
    id
    name
    members {
      id
      user {
        id
        firstName
        lastName
        emailAddress
        phoneNumber
      }
      tier {
        id
        name
        benefits {
          ... on SubscriptionBenefit {
            id
            name
            delivery
          }
        }
      }
      fulfillments(query: $query) {
        id
        isFulfilled
        isGift
        fulfillmentDate
        benefit {
          name
        }
        address {
          line1
          line2
          city
          state
          zip
          country
        }
        shippingNotes
        addons {
          id
          description
        }
        variant {
          id
          description
        }
      }
    }
  }
}
    `;
/**
 * __useBusinessFulfillmentsQuery__
 *
 * To run a query within a React component, call `useBusinessFulfillmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessFulfillmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessFulfillmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useBusinessFulfillmentsQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BusinessFulfillmentsDocument, options);
}
export function useBusinessFulfillmentsLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BusinessFulfillmentsDocument, options);
}
export function useBusinessFulfillmentsSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BusinessFulfillmentsDocument, options);
}
export const CreateFulfillmentDocument = gql `
    mutation CreateFulfillment($membershipTierId: ID!, $userId: ID!) {
  fulfillmentCreate(membershipTierId: $membershipTierId, userId: $userId) {
    id
  }
}
    `;
/**
 * __useCreateFulfillmentMutation__
 *
 * To run a mutation, you first call `useCreateFulfillmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFulfillmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFulfillmentMutation, { data, loading, error }] = useCreateFulfillmentMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCreateFulfillmentMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateFulfillmentDocument, options);
}
export const GetBenefitDocument = gql `
    query GetBenefit($id: ID!) {
  benefit(id: $id) {
    id
    name
  }
}
    `;
/**
 * __useGetBenefitQuery__
 *
 * To run a query within a React component, call `useGetBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBenefitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBenefitQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetBenefitDocument, options);
}
export function useGetBenefitLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetBenefitDocument, options);
}
export function useGetBenefitSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetBenefitDocument, options);
}
export const GetSubscriptionBenefitDocument = gql `
    query GetSubscriptionBenefit($id: ID!) {
  benefit(id: $id) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useGetSubscriptionBenefitQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionBenefitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionBenefitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionBenefitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionBenefitQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetSubscriptionBenefitDocument, options);
}
export function useGetSubscriptionBenefitLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetSubscriptionBenefitDocument, options);
}
export function useGetSubscriptionBenefitSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetSubscriptionBenefitDocument, options);
}
export const UpdateBenefitDocument = gql `
    mutation UpdateBenefit($id: ID!, $benefit: BenefitInput!) {
  updateBenefit(id: $id, benefit: $benefit) {
    ...BenefitFragment
  }
}
    ${BenefitFragmentFragmentDoc}`;
/**
 * __useUpdateBenefitMutation__
 *
 * To run a mutation, you first call `useUpdateBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBenefitMutation, { data, loading, error }] = useUpdateBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      benefit: // value for 'benefit'
 *   },
 * });
 */
export function useUpdateBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBenefitDocument, options);
}
export const LaunchBusinessDocument = gql `
    mutation LaunchBusiness($id: ID!) {
  launchBusiness(id: $id) {
    success
    error
    message
  }
}
    `;
/**
 * __useLaunchBusinessMutation__
 *
 * To run a mutation, you first call `useLaunchBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLaunchBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [launchBusinessMutation, { data, loading, error }] = useLaunchBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLaunchBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(LaunchBusinessDocument, options);
}
export const UpdateSquarespaceShopDocument = gql `
    mutation UpdateSquarespaceShop($id: ID!, $squarespaceShop: String) {
  updateBusiness(id: $id, business: {squarespaceShop: $squarespaceShop}) {
    id
    squarespaceShop
  }
}
    `;
/**
 * __useUpdateSquarespaceShopMutation__
 *
 * To run a mutation, you first call `useUpdateSquarespaceShopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSquarespaceShopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSquarespaceShopMutation, { data, loading, error }] = useUpdateSquarespaceShopMutation({
 *   variables: {
 *      id: // value for 'id'
 *      squarespaceShop: // value for 'squarespaceShop'
 *   },
 * });
 */
export function useUpdateSquarespaceShopMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateSquarespaceShopDocument, options);
}
export const CreateShopifyDocument = gql `
    mutation CreateShopify($id: ID, $name: String, $shopifyShop: String) {
  createShopifyApp(id: $id, name: $name, shopifyShop: $shopifyShop)
}
    `;
/**
 * __useCreateShopifyMutation__
 *
 * To run a mutation, you first call `useCreateShopifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShopifyMutation, { data, loading, error }] = useCreateShopifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      shopifyShop: // value for 'shopifyShop'
 *   },
 * });
 */
export function useCreateShopifyMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateShopifyDocument, options);
}
export const GetInstallLinkDocument = gql `
    query GetInstallLink($id: ID!) {
  business(id: $id) {
    id
    shopifyApp {
      installLink
    }
  }
}
    `;
/**
 * __useGetInstallLinkQuery__
 *
 * To run a query within a React component, call `useGetInstallLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallLinkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInstallLinkQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetInstallLinkDocument, options);
}
export function useGetInstallLinkLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetInstallLinkDocument, options);
}
export function useGetInstallLinkSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetInstallLinkDocument, options);
}
export const GetInstallLinkByShopifyShopDocument = gql `
    query GetInstallLinkByShopifyShop($shopifyShop: String!) {
  shopifyApp(shopifyShop: $shopifyShop) {
    installLink
  }
}
    `;
/**
 * __useGetInstallLinkByShopifyShopQuery__
 *
 * To run a query within a React component, call `useGetInstallLinkByShopifyShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstallLinkByShopifyShopQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstallLinkByShopifyShopQuery({
 *   variables: {
 *      shopifyShop: // value for 'shopifyShop'
 *   },
 * });
 */
export function useGetInstallLinkByShopifyShopQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(GetInstallLinkByShopifyShopDocument, options);
}
export function useGetInstallLinkByShopifyShopLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(GetInstallLinkByShopifyShopDocument, options);
}
export function useGetInstallLinkByShopifyShopSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(GetInstallLinkByShopifyShopDocument, options);
}
export const CreateBlankSimpleBenefitDocument = gql `
    mutation CreateBlankSimpleBenefit($membershipTier: ID!) {
  addBenefit(
    membershipTierId: $membershipTier
    benefit: {regular: {name: "A fun perk with every visit!"}}
  ) {
    id
    name
  }
}
    `;
/**
 * __useCreateBlankSimpleBenefitMutation__
 *
 * To run a mutation, you first call `useCreateBlankSimpleBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankSimpleBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankSimpleBenefitMutation, { data, loading, error }] = useCreateBlankSimpleBenefitMutation({
 *   variables: {
 *      membershipTier: // value for 'membershipTier'
 *   },
 * });
 */
export function useCreateBlankSimpleBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateBlankSimpleBenefitDocument, options);
}
export const CreateBlankSubscriptionBenefitDocument = gql `
    mutation CreateBlankSubscriptionBenefit($membershipTier: ID!) {
  addBenefit(
    membershipTierId: $membershipTier
    benefit: {subscription: {name: "Receive a surprise!", delivery: QUARTERLY}}
  ) {
    id
    name
    ... on SubscriptionBenefit {
      delivery
    }
  }
}
    `;
/**
 * __useCreateBlankSubscriptionBenefitMutation__
 *
 * To run a mutation, you first call `useCreateBlankSubscriptionBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlankSubscriptionBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlankSubscriptionBenefitMutation, { data, loading, error }] = useCreateBlankSubscriptionBenefitMutation({
 *   variables: {
 *      membershipTier: // value for 'membershipTier'
 *   },
 * });
 */
export function useCreateBlankSubscriptionBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(CreateBlankSubscriptionBenefitDocument, options);
}
export const DestroySubscriptionBenefitDocument = gql `
    mutation DestroySubscriptionBenefit($id: ID!) {
  destroyBenefit(id: $id) {
    ok
  }
}
    `;
/**
 * __useDestroySubscriptionBenefitMutation__
 *
 * To run a mutation, you first call `useDestroySubscriptionBenefitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroySubscriptionBenefitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroySubscriptionBenefitMutation, { data, loading, error }] = useDestroySubscriptionBenefitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroySubscriptionBenefitMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(DestroySubscriptionBenefitDocument, options);
}
export const UpdateMembershipDocument = gql `
    mutation UpdateMembership($id: ID!, $membershipInput: MembershipTierInput) {
  updateOrCreateMembership(businessId: $id, membershipInput: $membershipInput) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
/**
 * __useUpdateMembershipMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipMutation, { data, loading, error }] = useUpdateMembershipMutation({
 *   variables: {
 *      id: // value for 'id'
 *      membershipInput: // value for 'membershipInput'
 *   },
 * });
 */
export function useUpdateMembershipMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateMembershipDocument, options);
}
export const MembershipTierQueryDocument = gql `
    query MembershipTierQuery($id: ID!) {
  membershipTier(id: $id) {
    ...MembershipTierFragment
  }
}
    ${MembershipTierFragmentFragmentDoc}`;
/**
 * __useMembershipTierQueryQuery__
 *
 * To run a query within a React component, call `useMembershipTierQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembershipTierQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMembershipTierQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMembershipTierQueryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(MembershipTierQueryDocument, options);
}
export function useMembershipTierQueryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(MembershipTierQueryDocument, options);
}
export function useMembershipTierQuerySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(MembershipTierQueryDocument, options);
}
export const UpdateMembershipTierImageDocument = gql `
    mutation UpdateMembershipTierImage($membershipTierId: ID!, $imageInput: ImageInput!) {
  updateMembershipTierImage(
    membershipTierId: $membershipTierId
    imageInput: $imageInput
  ) {
    ok
  }
}
    `;
/**
 * __useUpdateMembershipTierImageMutation__
 *
 * To run a mutation, you first call `useUpdateMembershipTierImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMembershipTierImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMembershipTierImageMutation, { data, loading, error }] = useUpdateMembershipTierImageMutation({
 *   variables: {
 *      membershipTierId: // value for 'membershipTierId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateMembershipTierImageMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateMembershipTierImageDocument, options);
}
export const BusinessQueryDocument = gql `
    query BusinessQuery($id: ID!) {
  business(id: $id) {
    ...BusinessFragment
  }
}
    ${BusinessFragmentFragmentDoc}`;
/**
 * __useBusinessQueryQuery__
 *
 * To run a query within a React component, call `useBusinessQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessQueryQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(BusinessQueryDocument, options);
}
export function useBusinessQueryLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(BusinessQueryDocument, options);
}
export function useBusinessQuerySuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(BusinessQueryDocument, options);
}
export const UpdateBusinessDocument = gql `
    mutation UpdateBusiness($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...UpdateBusinessFragment
  }
}
    ${UpdateBusinessFragmentFragmentDoc}`;
/**
 * __useUpdateBusinessMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessMutation, { data, loading, error }] = useUpdateBusinessMutation({
 *   variables: {
 *      id: // value for 'id'
 *      business: // value for 'business'
 *   },
 * });
 */
export function useUpdateBusinessMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateBusinessDocument, options);
}
export const UpdateCoverPhotoDocument = gql `
    mutation UpdateCoverPhoto($businessId: ID!, $imageInput: ImageInput!) {
  updateCoverPhoto(businessId: $businessId, imageInput: $imageInput) {
    id
    coverPhoto {
      id
      url
      cdnPath
    }
  }
}
    `;
/**
 * __useUpdateCoverPhotoMutation__
 *
 * To run a mutation, you first call `useUpdateCoverPhotoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCoverPhotoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCoverPhotoMutation, { data, loading, error }] = useUpdateCoverPhotoMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateCoverPhotoMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateCoverPhotoDocument, options);
}
export const UpdateLogoDocument = gql `
    mutation UpdateLogo($businessId: ID!, $imageInput: ImageInput!) {
  updateLogo(businessId: $businessId, imageInput: $imageInput) {
    id
    logo {
      id
      url
      cdnPath
    }
  }
}
    `;
/**
 * __useUpdateLogoMutation__
 *
 * To run a mutation, you first call `useUpdateLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLogoMutation, { data, loading, error }] = useUpdateLogoMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      imageInput: // value for 'imageInput'
 *   },
 * });
 */
export function useUpdateLogoMutation(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useMutation(UpdateLogoDocument, options);
}
export const CustomerAnalyticsReportDocument = gql `
    query CustomerAnalyticsReport($id: ID!) {
  business(id: $id) {
    id
    reports(reports: ["CustomerAnalyticsReport"]) {
      title
      description
      ... on CustomerAnalyticsReport {
        complete
        averageOrderValue {
          amount
        }
        customerVisitFrequency
        customerData {
          totalCustomers
          totalCustomersWithEmail
          totalCustomersWithSMS
        }
      }
    }
  }
}
    `;
/**
 * __useCustomerAnalyticsReportQuery__
 *
 * To run a query within a React component, call `useCustomerAnalyticsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerAnalyticsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerAnalyticsReportQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerAnalyticsReportQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useQuery(CustomerAnalyticsReportDocument, options);
}
export function useCustomerAnalyticsReportLazyQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useLazyQuery(CustomerAnalyticsReportDocument, options);
}
export function useCustomerAnalyticsReportSuspenseQuery(baseOptions) {
    const options = Object.assign(Object.assign({}, defaultOptions), baseOptions);
    return Apollo.useSuspenseQuery(CustomerAnalyticsReportDocument, options);
}
